import { useMemo } from 'react'

import { ModalContext } from '@domain-group/suit-theme'

import { useModals, useSetState } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import ManageBrandImageSettingsPermissionsModal from '@modals/ManageBrandImageSettingsPermissionsModal'

import type { BrandModel } from '@models/types'

import PageContent from './components/PageContent'

const defaultState = {
  showManageBrandImageSettingsPermissionsModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    ManageBrandImageSettingsPermissionsModal: {
      closeModal: () => setState({ showManageBrandImageSettingsPermissionsModal: false }),
    },
  }

  return componentCallbacks[component] || {}
}
 interface ImageSettingsEditProps {
  brandId: number,
 }

const ImageSettingsEdit = (props: ImageSettingsEditProps) => {
  const { brandId } = props

  const [state, setState] = useSetState(defaultState)
  const {
    showManageBrandImageSettingsPermissionsModal,
  } = state

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      showManageBrandImageSettingsPermissionsModal: (payload: BrandModel) => {
        setModalData('ManageBrandImageSettingsPermissionsModal', payload)
        setState({ showManageBrandImageSettingsPermissionsModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent brandId={brandId} />

        <ManageBrandImageSettingsPermissionsModal
          callbacks={callbacks('ManageBrandImageSettingsPermissionsModal', setState)}
          showModal={showManageBrandImageSettingsPermissionsModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default ImageSettingsEdit
